import Autocomplete from './autocomplete';

export { type AutocompleteItem, type AutocompleteProps } from './autocomplete';
export default Autocomplete;
